// extracted by mini-css-extract-plugin
export default {"header":"DetailsPageHeader_header__TU7u3","header__title":"DetailsPageHeader_header__title__WNKLP","button":"DetailsPageHeader_button__k0YcJ"};